/**
 * Marker attribute for DOM subtrees that must never be readable in PostHog
 * session recordings. Consumed by `session_recording.maskTextSelector` in the
 * PostHog provider.
 *
 * rrweb resolves the selector against the element and its ancestors, so marking
 * a section container also masks every text node nested inside it.
 */
export const PRIVATE_MASK_ATTRIBUTE = "data-ph-mask";

/**
 * Class variant for call sites that can only forward a `className` to the
 * element holding the personal data, such as a shared form control's trigger.
 */
export const PRIVATE_MASK_CLASS = "ph-mask";

export const PRIVATE_MASK_SELECTOR = `[${PRIVATE_MASK_ATTRIBUTE}], .${PRIVATE_MASK_CLASS}`;

/**
 * PostHog's built-in block class. Masking only replaces text, so elements that
 * are personal data by themselves — a user photo, for instance — have to be
 * excluded from the recording instead of masked.
 */
export const BLOCK_CAPTURE_CLASS = "ph-no-capture";

/**
 * Spread onto an element whose text must stay unreadable in session recordings
 * (names, contact data, addresses, intercom codes, VAT numbers).
 *
 * Spread onto an existing container instead of wrapping the markup in a new
 * element — these sections are flex/grid layouts and an extra DOM node would
 * change how they render.
 */
export const privateProps = { [PRIVATE_MASK_ATTRIBUTE]: true } as const;
